"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propsArray = exports.optionalKeys = exports.filterParagraph = exports.filterNonParagraph = exports.PURPOSE_NAME = exports.PURPOSE_ICON = exports.PURPOSE = exports.PARAGRAPH_KEY = exports.PARAGRAPH_FIELDTYPE_NAMES = exports.PARAGRAPH_FIELDTYPE = exports.CParagraph = void 0;
var _block = require("./block");
var _embeddable = require("./embeddable");
var _publishable = require("./publishable");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const PARAGRAPH_KEY = exports.PARAGRAPH_KEY = 'Paragraph';
let PURPOSE = exports.PURPOSE = /*#__PURE__*/function (PURPOSE) {
  PURPOSE["CONVINCE"] = "convince";
  PURPOSE["EXPLAIN"] = "explain";
  PURPOSE["DESCRIBE"] = "describe";
  PURPOSE["DEMONSTRATE"] = "demonstrate";
  PURPOSE["COMPARE"] = "compare";
  PURPOSE["SOLVE"] = "solve";
  PURPOSE["REASON"] = "reason";
  PURPOSE["COMIC"] = "comic";
  return PURPOSE;
}({}); // comic
;
let PURPOSE_ICON = exports.PURPOSE_ICON = /*#__PURE__*/function (PURPOSE_ICON) {
  PURPOSE_ICON["convince"] = "fas fa-bullhorn";
  PURPOSE_ICON["explain"] = "fas fa-question";
  PURPOSE_ICON["describe"] = "fas fa-ruler";
  PURPOSE_ICON["demonstrate"] = "fas fa-chart-line";
  PURPOSE_ICON["compare"] = "fas fa-balance-scale";
  PURPOSE_ICON["solve"] = "fas fa-calculator";
  PURPOSE_ICON["reason"] = "fas fa-lightbulb";
  PURPOSE_ICON["comic"] = "fas fa-paw";
  return PURPOSE_ICON;
}({});
;
let PURPOSE_NAME = exports.PURPOSE_NAME = /*#__PURE__*/function (PURPOSE_NAME) {
  PURPOSE_NAME["convince"] = "Convince of";
  PURPOSE_NAME["explain"] = "Explain how";
  PURPOSE_NAME["describe"] = "Describe dimension";
  PURPOSE_NAME["demonstrate"] = "Demonstrate (data)";
  PURPOSE_NAME["compare"] = "Compare";
  PURPOSE_NAME["solve"] = "Solve";
  PURPOSE_NAME["reason"] = "Reason about (why)";
  PURPOSE_NAME["comic"] = "Comic";
  return PURPOSE_NAME;
}({});
;
const PARAGRAPH_FIELDTYPE = exports.PARAGRAPH_FIELDTYPE = {
  "subject": "text",
  "purpose": "custom",
  "concernedConcept": "custom",
  "addressedAspect": "custom",
  "position": "text",
  "implications": "text"
};
const PARAGRAPH_FIELDTYPE_NAMES = exports.PARAGRAPH_FIELDTYPE_NAMES = {
  "subject": "Subject",
  "purpose": "Purpose",
  "concernedConcept": "Concerned Concept",
  "addressedAspect": "Addressed Aspect",
  "position": "Position",
  "implications": "Implications"
};
class CParagraph {
  constructor() {
    //paragraphType: CONCEPT_CATEGORY | null = null; // the category of the paragraph
    //abbreviation: string | null = null; // the abbreviation of the paragraph
    _defineProperty(this, "purpose", null);
    // the purpose of the paragraph
    _defineProperty(this, "subject", null);
    // the subject of the paragraph
    _defineProperty(this, "implications", null);
    // the implications of the paragraph
    _defineProperty(this, "position", null);
  } // the position inside the concept/aspect
}
exports.CParagraph = CParagraph;
;
;
const optionalKeys = exports.optionalKeys = [
// enter the key of the interface that is not in the class
'concernedConcept', 'addressedAspect'].concat(_block.optionalKeys).concat(_publishable.optionalKeys);

/**
 * The type of an array of the properties
 */

/**
 * An array of the properties
 */
//const propsArray: ArrParagraph = Object.keys(new CParagraph()) as ArrParagraph;
/* multiple parent classes */
const propsArray = exports.propsArray = [...Object.keys(new CParagraph()), ...Object.keys(new _block.CBlock()), ...Object.keys(new _embeddable.CEmbeddable()), ...Object.keys(new _publishable.CPublishable())];

/**
 * Get the properties from a bigger object
 * when collect==true, then also collect the optional keys that are only defined in the interface but not in the class
 */
const filterParagraph = (props, {
  fallback = {},
  override = {}
} = {}, collect = false) => {
  const data = Object.assign(propsArray.concat(collect ? optionalKeys : []).reduce((r, k) => {
    // do not overwrite the IEntry values with undefined
    return _objectSpread(_objectSpread({}, r), {}, {
      [k]: function (_props$k, _props$k$localeCompar) {
        if (props[k] !== undefined && ((_props$k = props[k]) === null || _props$k === void 0 || (_props$k$localeCompar = _props$k.localeCompare) === null || _props$k$localeCompar === void 0 ? void 0 : _props$k$localeCompar.call(_props$k, '')) !== 0) {
          return props[k];
        }
        if (fallback[k] !== undefined) {
          return fallback[k];
        }
        if (r[k] !== null) {
          return r[k];
        }
        return undefined;
      }()
    });
  }, new CParagraph()), override);
  return data;
};
exports.filterParagraph = filterParagraph;
const filterNonParagraph = props => Object.keys(props).reduce((r, k) => {
  return Object.assign(r, !propsArray.includes(k) ? {
    [k]: props[k]
  } : {});
}, {});
exports.filterNonParagraph = filterNonParagraph;